<div style="overflow-x: clip">
  <div [appStoryblok]="_editable()" class="row">
    @for (blok of body(); track blok._uid) {
      @if (components) {
        <ng-template [ngComponentOutlet]="components[blok.component]" [ndcDynamicInputs]="blok">
        </ng-template>
      }
    }
  </div>
</div>
